import { RANGE_MAX_DB, RANGE_MIN_DB } from './audioLevel';

export const SERIAL_RANGE_MIN = 1;
export const SERIAL_RANGE_MAX = 10;

const SERIAL_STEP_DB = (RANGE_MAX_DB - RANGE_MIN_DB) / SERIAL_RANGE_MAX;

const clampSerial = (serial) => Math.max(
  SERIAL_RANGE_MIN,
  Math.min(SERIAL_RANGE_MAX, serial),
);

export const serialToLowDbfs = (serial) => (
  RANGE_MIN_DB + (clampSerial(serial) - 1) * SERIAL_STEP_DB
);

export const serialToHighDbfs = (serial) => (
  RANGE_MIN_DB + clampSerial(serial) * SERIAL_STEP_DB
);

export const lowDbfsToSerial = (dbfs) => clampSerial(
  Math.floor((dbfs - RANGE_MIN_DB) / SERIAL_STEP_DB) + 1,
);

export const highDbfsToSerial = (dbfs) => clampSerial(
  Math.ceil((dbfs - RANGE_MIN_DB) / SERIAL_STEP_DB),
);

export const dbfsRangeToSerialRange = (lowDbfs, highDbfs) => {
  const lowSerial = lowDbfsToSerial(lowDbfs);
  return {
    lowSerial,
    highSerial: Math.max(lowSerial, highDbfsToSerial(highDbfs)),
  };
};

export const VOICE_LOUDNESS_SERIAL_RANGES = Array.from(
  { length: SERIAL_RANGE_MAX },
  (_, index) => {
    const serial = index + SERIAL_RANGE_MIN;
    return {
      serial,
      lowDbfs: serialToLowDbfs(serial),
      highDbfs: serialToHighDbfs(serial),
    };
  },
);